import React from 'react'
import VelocityIMG from '../components/photos/Heritage2025Comp.webp'
import { Link } from 'react-router-dom'

export default function Velocity() {
    return (
        <div className='fullpage'>
            <div className='hero-image heritage'>
                <div className='overlay-cover'>
                    <img className='cover-img' alt='Heritage Singers' src={VelocityIMG} />
                </div>
            </div>
            <div className='hero-title'>
                <h1>Velocity</h1>
            </div>

            <div className='container'>
                <div className='row d-flex justify-content-center text-center'>
                    <p className='col-10'>Franklin Community Middle School Velocity is a.... Glornip wexudo fandal breezum 
                        korthin yindle pravat smorgle tindor flazzen quivra moltek zanthur prindle vexor clomish drevunk farlo 
                        spicket trablin zenthra kumble fornix wuddle sprantor glimvek zobbish trelun fanzor mydrak plofkin zegral 
                        thrindle jorvat plurnish exovo yambor crindle fextor zummish dravik boltra quevish lomper drindle smaggit v
                        ortin penkro yexal frummin squavish dorlen pruknar flimmel toxar venplo crondel brezar shuvrak moffin krindle z
                        ophet darnoq vixtral humbor splenkit trablo flunzer jextor murvin plozen trindle ravox qembar stolvik junbra 
                        quextor plivnat somber dranzik huffel gromtar wextal prindle zorvex lamber snuftik yovral cravix tundor mellin 
                        jorpex flamble pruzik trandle vexorn glenbra quastik polmir thraven joltek daxnor slimple vornik fezzor cronbit 
                        ralvex spumble jorlan texvin drindle flamox quezar brovin snorvak.</p>
                </div>
                <div className='row text-center my-5'>
                    <h2>2024 Season</h2>

                </div>

            </div>
        </div>
    )
}
